import { render, staticRenderFns } from "./CreditsNotesList.vue?vue&type=template&id=4431c3bc&scoped=true&"
import script from "./CreditsNotesList.vue?vue&type=script&lang=js&"
export * from "./CreditsNotesList.vue?vue&type=script&lang=js&"
import style0 from "./CreditsNotesList.vue?vue&type=style&index=0&id=4431c3bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4431c3bc",
  null
  
)

export default component.exports